/**
 * Dialog Constants
 * 
 * Centralized constants for dialog components
 */

// Setting category display names
export const SETTING_CATEGORY_LABELS = {
  complaintTypes: 'Type',
  complaintStatuses: 'Status',
  complaintPriorities: 'Priority',
  officerDesignations: 'Designation',
  authorityPrivileges: 'Authority Privilege',
  departments: 'Department',
};

// Dialog sizes
export const DIALOG_SIZES = {
  small: 'max-w-md',
  medium: 'max-w-2xl',
  large: 'max-w-4xl',
};

// Button variants
export const BUTTON_VARIANTS = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700',
  secondary: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

// File upload accepted types
export const ACCEPTED_FILE_TYPES = '.pdf,.doc,.docx,.jpg,.jpeg,.png';

// Priority options
export const PRIORITY_OPTIONS = ['Low', 'Medium', 'High'];

// Status options for complaints (default)
export const DEFAULT_COMPLAINT_STATUSES = [
  'Pending',
  'Under Investigation',
  'Under Review',
  'Approved',
  'Rejected',
];

